module.exports = __webpack_public_path__ + "img/umami.709aa920.svg";